import client from '../base-api';
import {IAddressBook, IAddressBookFilters, IAddressBookList} from "@/interfaces/AddressBook/IAddressBook";

const serviceURL = '/address-book/company';

const addressBookCompanyService = {

    getCompanies(filterData: IAddressBookFilters): Promise<{data: IAddressBookList}> {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getCompany(companyId: number) {
        return client.get(`${serviceURL}/${companyId}`);
    },
    postCompany(companyData: IAddressBook) {
        return client.post(`${serviceURL}`, companyData);
    },
    putCompany(companyData: IAddressBook, companyId: number) {
        return client.put(`${serviceURL}/${companyId}`, companyData);
    },
    deleteCompany(companyId: number) {
        return client.delete(`${serviceURL}/delete/${companyId}`);
    },

};

export default addressBookCompanyService;
  